import { PatternType, getPatternName } from '../types/pattern';

const CHART_PATTERN_TAG_LABELS: Record<string, string> = {
  breakout: 'Breakout',
  rsi_recovery: 'RSI recovery',
  stochastic_recovery: 'Stochastic recovery',
  support_retest: 'Support retest',
  fib_golden_zone: 'Fib golden zone',
  high_volume: 'High volume',
  ma_bounce_reversal: 'MA bounce reversal',
  ma150_v_reversal: 'MA150 V reversal',
  // Darvas Box: the chart pattern-tag code plus its detector status values so
  // result chips read cleanly whether tagged by pattern code or by box state.
  darvas_box: 'Darvas box',
  darvas_box_candidate: 'Darvas box (candidate)',
  darvas_box_breakout_confirmed: 'Darvas box (breakout)',
  darvas_box_failed_breakout: 'Darvas box (failed breakout)',
  darvas_box_invalidated: 'Darvas box (invalidated)',
  darvas_box_rejected: 'Darvas box (rejected)',
};

function titleCaseFromSnake(code: string): string {
  return code
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/** Human-readable label for chart-grid / API pattern tag codes (snake_case). */
export function getPatternTagLabel(code: string): string {
  const normalized = code.trim().toLowerCase();
  if (!normalized) return code;
  const enumValues = Object.values(PatternType) as string[];
  if (enumValues.includes(normalized)) {
    return getPatternName(normalized as PatternType);
  }
  const mapped = CHART_PATTERN_TAG_LABELS[normalized];
  if (mapped) return mapped;
  return titleCaseFromSnake(normalized);
}
